import {postRequest } from '@/sealFilter/requestAuthority'

let getRmdList = (data) => postRequest('/shoppingCart/action/rmdlist', data);//我的荐购/荐购直邮（不传用户id）
let getRmdall = (data) => postRequest('/shoppingCart/action/rmdlist', data);//我的荐购/荐购直邮（不传用户id）

let removeRmd = (data) => postRequest('/shoppingCart/action/rmdstat', data);

//平台设置查询
let getSystemList = (data) => postRequest('/rmd/rmdPlatformset/list', data);
//平台系统设置
let systemEdit = (data) => postRequest('/rmd/rmdPlatformset/edit', data);

let getActionRmdList = (data) => postRequest('/shoppingCart/action/rmddaishenpilist', data);//荐购汇总

let checkRmd = (data) => postRequest('/shoppingCart/action/rmdshenpi', data);//荐购审核

//收货地址管理
let queryAdress = (data) => postRequest('/rmd/tUseraddress/list', data);//查询收货地址历史列表
let addAdress = (data) => postRequest('/rmd/tUseraddress/add', data);//添加收货地址
let updateAdress = (data) => postRequest('/rmd/tUseraddress/edit', data);//修改收货地址
let deleteAdress = (data) => postRequest('/rmd/tUseraddress/remove', data);//删除收货地址

//修改荐购直邮订单地址
let changeRmdAddree = (data) => postRequest('shoppingCart/action/editrmdcartaddress', data);

//完善个人信息
let editPersonInfo = (data) => postRequest('/userlogin/action/edituserinfo', data);

//审核用户注册
let checkUserRegist = (data) => postRequest('/userlogin/action/batchusermobilephone', data);

//用户列表
let userList = (data) => postRequest('/userlogin/action/getuserinfolist', data);

//修改用户身份
let editUserAdmin = (data) => postRequest('/userlogin/action/modifyusershenfen', data);

//生成荐购订单
let getRmdOrder = (data) => postRequest('/shoppingCart/action/makermddanhao', data);

//荐购汇总单查询
let rmdOrderList = (data) => postRequest('/shoppingCart/action/rmdcollectlist', data);

//生成荐购订单
let exportOrder = (data) => postRequest('/shoppingCart/action/makermddanhao', data);

//查看当前机构的荐购规则，传入orgId和isDirect，没有的话就是空
let getNowRule = (data) => postRequest('/rmd/rules/get', data);

//更新或者新增荐购规则，根据orgId和isDirect，之前没有荐购规则的情况下就是新增，有荐购规则就是修改
let updateRule = (data) => postRequest('/rmd/rules/update', data);

//物流信息
let wuliuInfo = (data) => postRequest('/shoppingCart/action/express', data);
//确认签收
let getConfirm = (data) => postRequest('/shoppingCart/action/qianshou', data);

//无书目荐购列表
let noBooklist = (data) => postRequest('/tShoppingCartNocipbook/list', data);
//无书目荐购审核
let noBookAudit = (data) => postRequest('/tShoppingCartNocipbook/audit', data);
//无书目荐购列表
let noBookAdd = (data) => postRequest('/tShoppingCartNocipbook/add', data);
let removeNobook = (data) => postRequest('/tShoppingCartNocipbook/remove', data);
let updateNobook = (data) => postRequest('/tShoppingCartNocipbook/edit', data);

//新增用户
let addUser = (data) => postRequest('/userlogin/action/adduser', data);

//我的借阅记录
let getBorrowList = (data) => postRequest('/rmd/tUserborrowing/list', data); //借阅列表

let repayBack = (data) => postRequest('/rmd/tUserborrowing/guihuan', data);//归还

// 删除用户接口为替代接口，为临时假接口
let deleteUser = (data) => postRequest('/rmd/tUserborrowing/guihuan', data);//
// 修改用户接口为替代接口，为临时假接口
let updateUser = (data) => postRequest('/userlogin/action/edituserinfo', data);//

export{
    getRmdList,getRmdall, removeRmd, getSystemList, systemEdit, getActionRmdList, checkRmd, queryAdress, addAdress, updateAdress, deleteAdress, editPersonInfo,
    userList, editUserAdmin, checkUserRegist, getRmdOrder, rmdOrderList, exportOrder, changeRmdAddree, getNowRule, updateRule, wuliuInfo, getConfirm,
    noBooklist, noBookAudit, noBookAdd, removeNobook, updateNobook, deleteUser,updateUser,addUser, getBorrowList, repayBack
}


// WEBPACK FOOTER //
// ./src/api/manage.js